const lang = {
  challenge: {
    detail: {
      chall_detail_parti: "Participantes",
      chall_detail_reward: "Recompensas",
      chall_detail_reward_item: "Objetos",
      chall_detail_reward_badges: "Insignias",
      chall_detail_reward_badge: "Insignias",
      chall_detail_reward_point: "Puntos",
      chall_detail_goal: "Objetivo",
      chall_detail_dist: "Distancia",
      chall_detail_workout: "Entrenamiento",
      chall_detail_workout_detail: "Entrenamientos elegibles",
      chall_detail_intro: "Introducción",
      chall_detail_rank: "Tabla de clasificación",
      chall_detail_btn_join: "Unirse",
      chall_detail_time: "Termina en",
      chall_detail_time_days: "Días",
      chall_detail_status_my: "Mi estado",
      chall_detail_status_team: "Estado del equipo",
      chall_detail_status_rank: "Clasificación",
      chall_detail_status_progress: "Progreso",
      chall_detail_status_duration: "Duración",
      chall_detail_status_dist: "Distancia",
      chall_detail_status_cal: "Calorías",
      common_steps_low: "Pas",
      common_rep_count: "Número de rep.",
      chall_detail_status_day: "Días de entrenamiento",
      chall_detail_status_best: "Mejor resultado",
      chall_detail_status_contribution: "Mi contribución",
      chall_detail_btn_try: "Intentar de nuevo",
      chall_detail_btn_start: "Comenzar el desafío",
      chall_detail_btn_continue: "Continuar el desafío",
      chall_detail_btn_expired: "Desafío caducado",
      chall_detail_reward_item_claim: "Reclamar",
      chall_detail_reward_badge_display: "Mostrar",
      chall_detail_toast_unstart: "No se inició el desafío",
      chall_detail_toast_end: "El desafío finalizó",
      chall_detail_rank_empty:
        "No hay datos de la clasificación, comienza tu desafío y actualiza la tabla de clasificación.",
      chall_detail_workout_collection_mt: "Colección Específica",
      chall_detail_workout_route: "Información de la Ruta ",
      chall_detail_reward_mt: "Recompensas",
      chall_detail_workout_outrun: "Correr al aire libre",
      chall_detail_workout_outcycle: "Ciclismo al aire libre",
      chall_detail_workout_outwalk: "Caminata al aire libre",
      chall_detail_workout_yoga: "Yoga",
      chall_detail_workout_cardio: "Cardio",
      chall_detail_workout_strength: "Entrenamiento de fuerza",
      chall_detail_workout_stretch: "Estiramientos",
      chall_detail_workout_run: "Cinta",
      chall_detail_workout_cycle: "Ciclismo",
      chall_detail_workout_row: "Remo",
      chall_detail_workout_ellipt: "Elíptica",
      chall_detail_workout_step: "Escaladora",
      chall_detail_workout_rnr: "Row-N-Ride",
      chall_detail_workout_minibike: "Minibicicleta",
      chall_detail_workout_ski: "Máquina de esquí",
      chall_detail_workout_jump: "Saltar la cuerda",
      chall_detail_workout_vibration_treadmill: "Cinta de correr vibratoria",
      chall_detail_product_recommend: "Recomendación de productos",
      chall_detail_version_update_note: "Esta versión no admite esta función. Por favor, actualiza.",
      chall_detail_workout_stair: 'Escaladora',
      chall_detail_workout_slider: 'Escaladora Deslizante',

      chall_detail_workout_runcour: "Curso de running",
      chall_detail_workout_cyclecour: "Clases de ciclismo",
      chall_detail_workout_elliptcour: "Curso elíptico",
      chall_detail_workout_rowcour: "Curso de remo",
      chall_detail_workout_stepcour: "Curso de stepper",
      chall_detail_workout_prenatal: "Cursos de prenatal",
      chall_detail_workout_postpartum: "Cursos de postparto",
      chall_detail_workout_meditation: "Cursos de meditación",
      chall_detail_workout_rnrcourses: "Cursos de Row-N-Ride",
      chall_detail_workout_audio: "Audio cursos",
      chall_detail_workout_pilates: "Pilates",
      chall_detail_workout_climber: "Curso de Escalada",

      chall_detail_workout_all:
        "Todos los entrenamientos registrados por la aplicación Sunnyfit.",
      chall_detail_workout_collection:
        "Entrena con los cursos de esta colección",
      chall_detail_goal_intro:
        "Haz ejercicio durante {times} días, {value} {type} cada día.",
      chall_detail_team_join_mt: "Unirse a un equipo",
      chall_detail_team_create: "Crear equipo",
      chall_detail_team_join_conf: "Unirse al equipo",
      chall_detail_team_create_cxl: "Cancelar",
      chall_detail_team_create_conf: "Guardar",
      chall_detail_team_user_follow: "Seguir",
      chall_detail_team_user_assign: "Asignar como capitán",
      chall_detail_team_user_remove: "Eliminar del equipo",
      chall_detail_team_leave: "Abandonar el equipo",
      chall_detail_team_user_following: "Siguiendo",
      chall_detail_team_leave_note:
        "¿Seguro que quieres abandonar este equipo?",
      chall_detail_team_leave_cxl: "Cancelar",
      chall_detail_team_leave_conf: "Confirmar",
      chall_detail_team_me: "Yo",
      chall_detail_team_leave_toast:
        "Asigna el papel de capitán a uno de tus compañeros de equipo.",
      chall_detail_team_join_toast: "Selecciona un equipo",
      chall_detail_team_join_toast_full:
        "El equipo que seleccionaste está completo. Selecciona otro equipo o crea uno nuevo.",
      chall_detail_team_create_toast: "Introduce el nombre de tu equipo.",
      chall_detail_result_descrip_goal_com_1: "¡Felicidades!",
      chall_detail_result_descrip_goal_com_single:
        "Tu trabajo duro valió el esfuerzo. ¡Mantengamos el ritmo!",
      chall_detail_result_descrip_goal_com_team:
        "El trabajo duro de tu equipo valió el esfuerzo. ¡Mantengamos el ritmo!",
      chall_detail_result_descrip_goal_incom_1: "¡Sigue adelante! 💪",
      chall_detail_result_descrip_goal_incom_2:
        "Toma un respiro, reinicia y, ¡afrontemos juntos lo que viene!",
      chall_detail_result_descrip_other1_1: "Vaya, ¡estás en la cima!",
      chall_detail_result_descrip_other1_single:
        "Tu dedicación valió la pena. ¡Sigue liderando el camino e inspirando a otros!",
      chall_detail_result_descrip_other1_team:
        "La dedicación de tu equipo valió la pena. ¡Sigan liderando el camino e inspirando a otros!",
      chall_detail_result_descrip_other2_1: "¡Buen trabajo! 💪",
      chall_detail_result_descrip_other2_single:
        "¡Estás en el {rank} lugar! ¡Bien hecho!",
      chall_detail_result_descrip_other2_team:
        "¡Tu equipo está en el {rank} lugar! \n¡Bien hecho!",
      chall_detail_result_descrip_other3_single:
        "¡Conseguiste el {rank} lugar!",
      chall_detail_result_descrip_other3_team:
        "¡Tu equipo consiguió el {rank} lugar!",
      chall_detail_result_descrip_other3_2:
        "Sigue así, y ¡propongámonos conseguir un rango aún mayor la próxima vez!",
      chall_detail_result_reward: "Recompensas recibidas",
      chall_detail_result_done: "Hecho",
      chall_detail_result_share: "Compartir",
      chall_detail_result_reward_badge: "Insignias",
      chall_detail_result_reward_point: "Puntos",
      chall_detail_result_reward_item: "Objetos",
      chall_detail_workout_collection_time: "Tiempo estimado",
      chall_detail_start_workout: "Comenzar un entrenamiento",
      badge_detail_display: "Mostrar en perfil",
      badge_detail_remove: "Eliminar del perfil",
      badge_detail_display_toast: "Ahora se muestra en tu perfil",
      badge_detail_remove_toast: "Se eliminó de la pantalla del perfil",
      invite_from: "Invitación de",
      invite_from_friend: "Amigos",
      invite_from_contact: "Contactos",
      invite_from_more: "Más",
      address_edit_mt: "Dirección de envío",
      address_edit_note: "Todos los datos estarán cifrados",
      address_edit_country: "País / Región",
      address_edit_name: "Nombre",
      address_edit_street: "Dirección",
      address_edit_apt: "Departamento/suite/otro (opcional)",
      address_edit_city: "Ciudad",
      address_edit_state: "Estado",
      address_edit_code: "Código postal",
      address_edit_phone: "Número de teléfono",
      address_edit_btn: "Enviar",
      address_edit_state_select_mt: "Seleccionar el estado",
      address_edit_check: "Comprobar la dirección",
      address_edit_check_note:
        "Comprueba la dirección para garantizar que la entrega se realice correctamente. No se reemplazarán los premios perdidos.",
      address_edit_check_cxl: "Cancelar",
      address_info_mt: "Dirección de envío",
      address_info_name: "Nombre",
      address_info_phone: "Teléfono",
      address_info_address: "Dirección",
      common_courses_count: "Cursos",
      challenge_exchange_title1: 'Está interesado en gastar ',
      challenge_exchange_title2: ' puntos para unirse?',
      challenge_exchange_mypt: 'Mis Puntos:',
      challenge_exchange_button1: 'Unirse con %s puntos',
      challenge_exchange_button2: 'Ganar más puntos',
      challenge_exchange_button3: 'Cancelar',
      challenge_exchange_toast: 'Registro exitoso',
      
      chall_detail_workout_select_route: 'Seleccione una ruta',
      chall_detail_workout_route_select: 'Seleccione esta ruta.',
      chall_detail_workout_change_route: 'Cambiar',
      chall_detail_workout_my_route: 'Mi ruta',
      chall_detail_status_scoring_rules: 'Reglas de puntuación',
      
      chall_scoring_rules_main_title: "Desglose de Puntaje 🏆",
      chall_scoring_rules_goal_title: "🏁 Completado (s% pts)",
      chall_scoring_rules_goal_descrip: "Alcanza la distancia objetivo para asegurar tus puntos por completado.\nEstado: Conseguido inmediatamente al alcanzar la distancia.",
      chall_scoring_rules_speed_title: "⚡ Velocidad (max s% pts)",
      chall_scoring_rules_speed_descrip: "¡Cuanto más rápido termines, más alta será tu puntuación! Tu bonificación por velocidad se calcula en el momento exacto en que alcanzas la distancia objetivo.\nConsejo: Menor tiempo de llegada = Mayor rango.",
      chall_scoring_rules_bonus_title: "🎯 Bono por repetición (max s% pts)",
      chall_scoring_rules_bonus_descrip: "¡La constancia da sus frutos! Gana +1 punto extra cada vez que repitas este desafío (hasta s% pts).",
      chall_scoring_rules_ranking_title: "🥇 Reglas de clasificación",
      chall_scoring_rules_ranking_descrip: "Puntuación total: Tu puntuación final = Objetivo + Velocidad + Bonificación (máximo 100 pts).\nBloqueo: Las puntuaciones se bloquean en el momento en que alcanzas el objetivo. Continuar moviéndose es solo para el seguimiento del ejercicio y no cambiará tu clasificación.\nDesempate: Si las puntuaciones son iguales, gana el tiempo de llegada más rápido.",
      
      share_challenge_poster_bub: '¡Únete a mí en este desafío! 🏆️',
      share_poster_sologn: 'Entrena gratis, crece con Sunny Fam 👉',
      share_poster_challenge_success: 'Succès dans le Défi',

      common_block_pop_title: "Uso Limitado",
      chall_detail_join_limit_content: 'Debido a la detección de un comportamiento anormal de recolección de datos, y con el fin de garantizar la equidad de la comunidad, tus funciones de Desafío han sido restringidas.',
      me_contact: 'Comunícate con nosotros',
    },
  },
  workout: {
    collection: {
      detail: {
        workout_course_collection_detail_mt: "Colección",
        workout_wt_collection_detail_mt: "Colección de la Gira mundial",
        workout_course_collection_detail_count: "Cursos",
        workout_course_collection_detail_limit: "Curso por tiempo limitado",
      },
    },
  },
  support: {
    equipment: {
      detail: {
        equip_support_equip_main: "Equipo de soporte",
        equip_support_equip_enter_tips: "Por favor, ingrese el modelo de su equipo:",
        equip_support_equip_enter_content: "Ingresar Modelo...",
        equip_support_equip_tips_main: "Consejos",
        equip_support_equip_tips_content: "Si no conoce el modelo del dispositivo, puede consultar la etiqueta del cuerpo, como se muestra en la imagen de abajo.",
        equip_support_equip_contact_us_btn: "Comunícate con nosotros",
        equip_support_equip_view_courses_btn: "Ver Cursos",
        btn_common_ok: "OK",
        btn_common_search: "Buscar",
      },
    },
  },
  contact: {
    detail: {
      contact_us_mt: "Comunícate con nosotros",
      contact_us_feedback: "Enviar comentarios",
      contact_us_note:
        "Envía tus comentarios o problemas, y nos comunicaremos contigo en un plazo de 2 días hábiles.",
      contact_us_issue_type: "Necesito ayuda con",
      contact_us_issue_type_input: "Selecciona el problema",
      contact_us_name: "Nombre completo",
      contact_us_name_input: "Escribe aquí tu nombre completo",
      contact_us_equip: "Modelo del equipo",
      contact_us_equip_input: "Introduce el número de modelo del equipo",
      contact_us_email: "Correo electrónico",
      contact_us_email_input: "Escribe aquí tu correo electrónico",
      contact_us_describe: "Describe el problema",
      contact_us_describe_input: "Deja tu mensaje aquí",
      contact_us_image: "Adjunto Imagen/Video",
      contact_us_contact_info: "Información de contacto",
      btn_common_send: "Enviar",
      btn_common_submit: "Submit",
      contact_us_issue_type_mt: "Tipo de problema",
      contact_us_issue_type_equip: "Problemas con el equipo",
      contact_us_issue_type_equip_note:
        "Problema con el contador/piezas dañadas/faltantes",
      contact_us_issue_type_app: "Problemas con la aplicación",
      contact_us_issue_type_app_note: "Características/Experiencia del usuario",
      contact_us_issue_type_suggest: "Sugerencias",
      contact_us_issue_type_suggest_note: "Agregar cursos/Agregar funciones",
      contact_us_issue_type_equip_meter: "Problema del contador",
      contact_us_issue_type_equip_damage: "Piezas dañadas/faltantes",
      contact_us_issue_type_app_regist: "Inscripción/registro",
      contact_us_issue_type_app_connect: "Conexión por Bluetooth",
      contact_us_issue_type_app_googlefit: "Google Fit",
      contact_us_issue_type_app_applehealth: "Salud de Apple",
      contact_us_issue_type_app_video: "Reproducción de video/audio",
      contact_us_issue_type_app_plan: "Planes y cursos/programas planificados",
      contact_us_issue_type_app_account: "Cuenta y perfil",
      contact_us_issue_type_app_update: "Actualizar la versión",
      contact_us_issue_type_app_data: "Anomalías en los datos",
      contact_us_issue_type_app_other: "Otros problemas de la aplicación",
      contact_us_issue_type_app_wifi: "Conexión por Wi-Fi",
      contact_us_result_mt: "¡Gracias por tus comentarios!",
      contact_us_result_st:
        "Nos comunicaremos contigo en un plazo de 2 días hábiles.",
      btn_common_done: "Hecho",
      btn_common_next: "Siguiente",

      btn_common_camera: "Cámara",
      btn_common_photo_album: "Elige foto del álbum",
      btn_common_video_album: "Elige video del álbum",
      btn_common_cancel: "Cancelar",

      camera_note_main: "Permiso de cámara",
      camera_note_content: "Necesitamos acceso a tu cámara para subir contenido.",
      photo_note_main: "Permiso de fotos",
      photo_note_content:
        "Necesitamos acceso a tus fotos para subir contenido.",

      photo_note_btn_open_settings: "Abrir Configuración",
      uploading_note_main: "Subiendo tus comentarios...",
      uploading_note_schedule: "{currentUploadIndex} de {totalUploadCount} archivos subidos",
      uploading_note_tips: "El archivo de video puede tardar más",

      album_attach_upload_failed_toast: "Error al subir. Inténtalo de nuevo.",
      album_attach_image_toast: "Puedes adjuntar hasta {number} imágenes",
      album_attach_image_length_toast: "Puedes seleccionar imágenes de hasta {size} MB cada una",
      album_attach_video_toast: "Puedes adjuntar hasta {number} video",
      album_attach_video_length_toast1: "Por favor, selecciona un vídeo dentro de {number} segundos.",
      album_attach_video_size_toast: "Por favor, selecciona un vídeo dentro de {number} MB.",
    },
  },
  workoverview: {
    detail: {
      common_steps: "Pasos",
      common_steps_low: "pasos",
      workout_result_mt: "Datos del entrenamiento",
      workout_result_cal_in: "Las calorías en",
      workout_result_hamburger: "Hamburguesa",
      workout_result_hamburger_note:
        "Una {name} equivale aproximadamente a {value} calorías",
      workout_result_data_time: "Tiempo",
      workout_result_data_dis: "Distancia",
      workout_result_data_cal: "Calorías",
      workout_result_data_height: "Altura",
      workout_result_data_floors: "Pisos",
      workout_result_data_cal_note:
        "Las calorías quemadas mostradas en tu aplicación se basan en tu altura y peso, por lo que pueden ser inconsistentes con los datos de tu equipo.",
      workout_result_data_floor_note:
        "Una planta es aproximadamente de 2.5 metros.",
      workout_result_data_steps: "paso",
      workout_result_data_stroke: "Carreras",
      workout_result_data_stride: "Conteo de pasos",
      workout_result_data_max_jumps: "Saltos Máximos",
      workout_result_data_avg: "Promedio",
      workout_result_data_max: "Máx.",
      workout_result_data_rep: "Número de rep.",
      workout_result_data_reps: "Repeticiones",
      workout_result_data_hr: "RRHH",
      workout_result_data_hr_analysis: "Análisis cardíaco",
      workout_result_data_hr_zone: "Zona {index}",
      workout_result_data_speed: "Velocidad",
      workout_result_data_pace: "Ritmo",
      workout_result_pace_fast: "Rápido",
      workout_result_data_resist: "Resistencia",
      workout_result_data_cadence: "Cadencia",
      workout_result_data_spm: "SPM",
      workout_result_data_str: "Tasa de la carrera",
      workout_result_evaluate: "Evaluar",
      workout_result_post: "Publier mon résultat",
      workout_result_share_video: "Compartir gran video",
      workout_result_wu: "Calentamiento",
      workout_result_main: "Principal",
      workout_result_cd: "Enfriamiento",
      workout_result_treadmill: "Entrenamiento en cinta de correr",
      workout_result_bike: "Ciclismo de interior",
      workout_result_elliptical: "Entrenamiento en elíptica",
      workout_result_rnr: "Entrenamiento de remo y ride",
      workout_result_rower: "Entrenamiento en remo",
      workout_result_stepper: "Entrenamiento en escaladora",
      workout_result_data_incline: "Inclinación",
      workout_result_run: "Correr al aire libre",
      workout_result_walk: "Caminar al aire libre",
      workout_result_cycling: "Ciclismo al aire libre",
      workout_result_result_workout: "Cantidad",
      workout_result_chall_score: "Puntuación",
      workout_result_map_hide_note: "El mapa se ocultará cuando compartas.",
      workout_result_on_equipment: "En el equipo",
      workout_result_off_equipment: "Fuera del equipo",
      btn_common_done: "Hecho",
      btn_common_share: "Compartir",
      btn_common_try_again: "Intentar de nuevo",
      common_completed: "Completado",
      common_remaining: "Restante",
      share_common_open: "Abierto",
      social_user_follow: "Seguir",
      social_user_following: "Siguiendo",
      share_common_join_us: "Únete a nosotros",
      workout_result_movement_tag: "Movimient",
      workout_result_movement_note: "Este entrenamiento de movimientos está personalizado según el plan de IA. ¿Quieres crear tu plan exclusivo?",
      btn_try_now: "Prueba ahora",
      workout_result_share: 'Share My Result',
      workout_result_movement_feedback: "Comentarios",
      workout_result_movement_feedback_mt: "Tus comentarios nos ayudan a mejorar",
      workout_result_movement_feedback_tip: "¿Cómo te ha parecido este entrenamiento?",
      workout_result_rpe_ask: "¿Cómo se sintió esta sesión?",
      workout_result_rpe_easy: "Fácil",
      workout_result_rpe_challenge: "Reto",
      workout_result_rpe_level1: "Sin esfuerzo",
      workout_result_rpe_level2: "Muy fácil",
      workout_result_rpe_level3: "Cómodo",
      workout_result_rpe_level4: "Empezando a sudar",
      workout_result_rpe_level5: "Un poco sin aliento",
      workout_result_rpe_level6: "Se pone difícil",
      workout_result_rpe_level7: "Cuesta hablar",
      workout_result_rpe_level8: "Respiración intensa",
      workout_result_rpe_level9: "Casi al límite",
      workout_result_rpe_level10: "Sin fuerzas",
      workout_result_rpe_submit: "Enviar",
      workout_result_rpe_submit_fail:
        "No se pudo enviar. Inténtalo de nuevo.",
      workout_result_rpe_loading_line1: "RPE: {n}/10. ¡Entendido!",
      workout_result_rpe_loading_line2:
        "Estoy revisando tu entrenamiento...",
      workout_result_coach_insight: "Consejo del coach",
      workout_result_ai_rpe_caption: "RPE : {n} / 10",
      workout_result_rpe_note:
        "RPE significa índice de esfuerzo percibido. Indica qué tan duro se sintió tu entrenamiento en una escala del 1 al 10.",
      workout_result_ask_coach: "Preguntar al coach",
      btn_common_submit: "Enviar",
    },
  },
  midYearReport: {
    workoutData_burnCalories: "Calorías Totales Quemadas",
    workoutData_workoutTimes: "Total Entrenamientos",
    workoutData_workoutDays: "Días de Ejercicio",
    workoutData_workoutDuration: "Tiempo de Ejercicio",

    community_title: "¡Gracias por contribuir y ser parte de la comunidad SunnyFit!",
    community_friendsRanking: "Clasificación entre Amigos",
    community_rankOpen: "En el ",
    community_rankEnd: " superior entre amigos",
    community_postShares: "Publicaciones Compartidas",
    community_likesReceived: "Publicaciones Que Les Gustaron",
    community_share_unit: "Publicaciones",
    community_like_unit: "Me Gusta",

    // favoriteWorkout_title: "Entrenamiento favorito",
    favoriteWorkout_totalNumberOfWorkouts: " Entrenamientos Completados",
    favoriteWorkout_equivalentToSeveralBurgers: "Calorías Quemadas Equivalentes A",
    favoriteWorkout_totalDistance_Metric: "Distancia total en kilómetros", 
    favoriteWorkout_totalDistance_Imperial: "Distancia total en millas",
    favoriteWorkout_MaxRPMAchieved: "Máximo RPM Alcanzado",
    favoriteWorkout_MaxSPMAchieved: "Máximo SPM Alcanzado",
    favoriteWorkout_TotalDuration: "Duración total",
    favoriteWorkout_TotalCaloriesBurned: "Calorías Quemadas",
    favoriteWorkout_fastestPace: "Tu mejor ritmo completado",
    favoriteWorkout_fastestCadence: "Tu cadencia más rápida completada",
    favoriteWorkout_maxStrokes: "Tu máximo de golpes completado",
    favoriteWorkout_maxFrequency: "Tu cadencia más rápida completada",
    favoriteWorkout_totalDaysOfWorkout: "Días Totales de Entrenamientos de &*& ",

    favorite_favorite: "Favorite",
    favoriteTrainer_descTime: "En los últimos seis meses, has tomado cursos de entrenamiento con &*& Entrenadores de Sunny",
    favoriteTrainer_descTrain: "Has completado &*& cursos con tu entrenador favorito, &*& !",

    // favoriteCourses_accompanyYou: "acompañándote",
    favoriteCourses_title: "¡Se añaden nuevos cursos a SunnyFit cada semana!",
    favoriteCourses_coursesDesc: "¡Eso es equivalente a ver &*& películass!",

    noData_title: "Informe de entrenamiento de SunnyFit",
    noData_info: "Los datos de entrenamiento que proporcionaste para 2024 no son suficientes.",

    common_share: "Compartir",
    common_back: "Volver",
    common_joinNow: "Únete Ahora",
    common_update: "Por favor, actualiza a la última versión.",
  },
  pointsMall:{
    product:{
      detail: {
        "product_detail_top_title":"Detalles del Producto",
        "product_detail_mypoints":"Mis Puntos:",
        "product_detail_exchange":"Intercambiar",
        "product_detail_earn":"Ganar más Puntos",
        "product_detail_stock":"Agotado de Existencia",
        "product_detail_null_title":"Los datos son anormales, inténtelo de nuevo más tarde.",
        "product_detail_null_button":"Actualizar",
        "product_detail_promotional1": "Fin Limitado %s Días",
        "product_detail_promotional2": "Limitado | Solo %s Restantes",
        "product_detail_promotional3": "Limitado | Agotado",
        "product_detail_gift_others": "Regalo para Otros",
        "product_detail_gift_myself": "Regalo para Mí"
      }
    },
    order:{
      detail: {
        "exchange_detail_my_order_title":"Mi Pedido",
        "exchange_detail_view_points":"Mis Puntos",
        "exchange_detail_discount": "Descuento",
        "exchange_detail_expected_deduction":"Deducción Esperada",
        "exchange_detail_balance":"Saldo",
        "exchange_detail_out_of_stock":"Actualmente no tenemos stock de este artículo. Por favor, inténtelo de nuevo pronto.",
        "exchange_detail_redemption_toast":"El canje excede el límite.",
        "exchange_detail_confirm_exchange":"Confirmar Intercambio",

        "exchange_successful_title":"Canje Exitoso",
        "exchange_successful_goods_send_info":"Tu artículo será enviado pronto. Puedes consultar el progreso en los detalles de tu pedido.",
        "exchange_successful_check_order_detail":"Para iniciar el proceso de canje, consulte detalladamente su pedido.",
        "exchange_successful_back":"Volver",
        "exchange_successful_view":"Ver Detalles del Pedido",

        "orders_history_detail_address_title1":"Teléfono",
        "orders_history_detail_address_title2":"Dirección",
        "orders_history_detail_address_title3":"Correo electrónico",
        "orders_history_null_title": "Aquí está vacío",
        "address_detail_add_shipping_address":"Agregar Dirección de Envío",
        "address_detail_add":"Agregar",
        "address_detail_default":"Predeterminado",
        "address_detail_set_as_default":"Por defecto",
        "address_detail_my_address":"Mi Dirección",
        "address_detail_delete":"Eliminar",
        "address_detail_edit":"Editar",
        "address_detail_add_a_shipping_address":"+ Agregar una Dirección de Envío",
        "address_detail_delete_tips":"Consejos para Eliminar",
        "address_detail_toast":"¿Está seguro de eliminar esta dirección?",
        "address_detail_cancel":"Cancelar",
        "address_detail_delete":"Eliminar",

        "shipping_address_title":"Dirección de Envío",
        "shipping_address_data_encryption_info":"Toda la información será encriptada",
        "shipping_address_country_region":"País/Región",
        "shipping_address_first_name":"Nombre",
        "shipping_address_first_name_prompt":"Por favor, introduzca su Nombre",
        "shipping_address_last_name":"Apellido",
        "shipping_address_last_name_prompt":"Por favor, introduzca su Apellido",
        "shipping_address_address_line_1":"Línea de Dirección 1",
        "shipping_address_address_line_1_desc":"Nombre de la calle y número de la calle, nombre de la empresa",
        "shipping_address_address_line_2":"Línea de Dirección 2",
        "shipping_address_address_line_2_sub":"(Opcional) ",
        "shipping_address_address_line_2_desc":"Edificio/Apartamento/Suite número, Unidad, Piso, etc",
        "shipping_address_state":"Estado",
        "shipping_address_state_prompt":"Por favor, seleccione el Estado",
        "shipping_address_city":"Ciudad",
        "shipping_address_city_prompt":"Por favor, introduzca su Ciudad",
        "shipping_address_zip_code":"Código Postal",
        "shipping_address_zip_code_prompt":"Por favor, introduzca el Código Postal",
        "shipping_address_phone_number":"Número de Teléfono",
        "shipping_address_phone_number_prompt":"Por favor, introduzca su Número de Teléfono",
        "shipping_address_email_address":"Dirección de Correo Electrónico",
        "shipping_address_email_address_desc":"Para recibir información de envío",
        "shipping_address_security_privacy_info":"Seguridad y Privacidad",
        "shipping_address_security_privacy_desc":"Mantenemos medidas físicas, técnicas y administrativas de estándar industrial para proteger su información personal.",
        "shipping_address_save":"Guardar",
        "shipping_address_name":"Por favor, ingrese su nombre y apellido con 2 a 32 caracteres.",
        "shipping_address_toast":"Disculpe, pero nuestro programa de canje de puntos actualmente solo está disponible para los usuarios en los 48 estados contiguos de Estados Unidos.",

        "orders_history_top_title":" Historial Pedidos",
        "orders_history_list_view":"Ver Detalle",
        "orders_history_list_date":"Fecha de Intercambio:",
        "orders_history_null_button":"Intercambio de Puntos",
        "orders_history_detail_top_title":"Detalle del Pedido",
        "orders_history_detail_tracking_title":"Número de seguimiento",
        "orders_history_detail_coupon_code":"Código de cupón",
        "orders_history_detail_coupon_time":"Fecha de expiración del cupón",
        "orders_history_detail_tracking_state":"Procesamiento",
        "ordershi_history_detail_date_title":"Fecha de Intercambio",
        "orders_history_detail_spend_title":"Gasto",
        "orders_history_detail_order_title":"Número de pedido",
        "orders_history_detail_instructions":"Instrucciones",
        "orders_history_detail_copy":"Copiar",
        "orders_history_detail_copy_toast":"La copia se ha realizado con éxito",
        "orders_history_tab_1":"Comandos de intercambio",
        "orders_history_tab_2":"Pedidos de cursos",
  
      "invite_reward_order_type":"Invita y gana",
      "event_reward_order_type":"Premio Evento",

      "rewards_points_toast_error200": "Pedido creado exitosamente",
      "rewards_points_toast_error302": "Promoción inválida",
      "rewards_points_toast_error404": "Los datos son anormales, inténtelo de nuevo más tarde.",
      "rewards_points_toast_error412": "Los datos son anormales, inténtelo de nuevo más tarde.",
      "rewards_points_toast_error999": "Los datos son anormales, inténtelo de nuevo más tarde.",
      "rewards_points_toast_error14001": "Artículo discontinuado",
      "rewards_points_toast_error14002": "Actualmente no tenemos stock de este artículo. Por favor, inténtelo de nuevo pronto.",
      "rewards_points_toast_error14003": "Puntos insuficientes",
      "rewards_points_toast_error14004": "Canje excede el límite",
      "rewards_points_toast_error14005": "No dentro del período de la promoción",
      "rewards_points_toast_error14006": "Canje limitado de la promoción agotado",
      "rewards_points_toast_error14008": "El regalo ya ha sido reclamado",
      "rewards_points_toast_error14010": "Fuera del período de validez para reclamar – El regalo ha sido devuelto",
      }
    },
  },
  common: {
    common_no_content: "Sin contenido",
    common_loading_failed: "Error al cargar",
    common_refresh: "Actualizar",
    common_loading: "Cargando",
    common_points: "Puntos",
    common_intensity_beg: "Principiante",
    common_intensity_int: "Intermedio",
    common_intensity_adv: "Avanzado",
    common_no_more_data: "Sin más datos",
    common_days: "días",
  },
  workoutType: {
    Treadmill: "Rodillo",
    IndoorBike: "Bici Interior",
    Elliptical: "Elíptico",
    Stepper: "Escaladora",
    Rowing: "Remo",
    RowNRide: "Row-N-Ride",
    Cardio: "Cardio",
    Yoga: "Yoga",
    Strength: "Fuerza",
    prenatal: "Prenatal",
    postpartum: "Postparto",
    meditation: "Meditación",
    Audio: "Audio",
    Stretching: "Estiramiento",
    outdoorRunning: "Correr al aire libre",
    outdoorCycling: "Ciclismo exterior",
    outdoorWalking: "Caminata al aire libre",
  }
};
export default lang;



// WEBPACK FOOTER //
// ./src/locales/es.js